import { useRouterState } from "@tanstack/react-router";
import { useEffect, useState } from "react";

/** Barra fina no topo, nas cores da logo, enquanto uma página nova carrega. */
export default function NavigationProgress() {
  const loading = useRouterState({ select: (s) => s.status === "pending" });
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!loading) {
      setVisible(false);
      return;
    }
    const t = setTimeout(() => setVisible(true), 120);
    return () => clearTimeout(t);
  }, [loading]);
  if (!visible) return null;
  return (
    <div
      role="progressbar"
      aria-label="Carregando página"
      className="fixed inset-x-0 top-0 z-[200] h-[3px] overflow-hidden"
    >
      <div className="h-full w-full animate-pulse bg-gradient-to-r from-brand-green via-brand-blue to-brand-yellow" />
    </div>
  );
}
